import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../../Header';
import $ from 'jquery';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import moment from 'moment';
class PerformanceReviews extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            apiUrl: this.decryptconfigdata('apiUrl'),
            userAuthKey: has_local_data ? localdata.user_key : '',
            userId: has_local_data ? localdata.user_id : '',
            userEmail: has_local_data ? localdata.user_email : '',
            users: [],
            search: '',
            permissions: [],
            MyPerform_question: [],
            MyPerform_answer: [],
            comment_result:[],
            hr_permission: '',
            department: 'all',
            message: '',
            activePage: 1,
            item_count: '',
            isLoadMore: 1,
            activePage: 1,
            loading: 1,
            empId: '',
            emp_detail: [],
            startDate: moment(),
            endDate: moment(),
            credit_reward_date: moment(),
            fields: {},
            errors: {},
            registered_mail: '',
            first_half_checked: 0,
            second_half_checked: 0,
        };

        this.handlePageChange = this.handlePageChange.bind(this);
        this.searchChange = this.searchChange.bind(this);
        this.departmentChange = this.departmentChange.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    handlePageChange(pageNumber) {
        this.setState({ activePage: pageNumber });
        this.userList(pageNumber);
    }

    onChange(event) {
        let fields = this.state.fields;
        this.setState({ [event.target.name]: event.target.value });
        fields[event.target.name] = event.target.value;

    }
    searchChange(event) {
        this.setState({ search: event.target.value }, function () {
            this.userList();
        });
    }
    departmentChange(event) {
        this.setState({ department: event.target.value }, function () {
            this.userList();
        });
    }
    id(id) {
        fetch(this.state.apiUrl + '/MyPerformanceRest/ViewReport/id/' + id + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                this.setState({
                    MyPerform_answer: findresponse.MyPerform_answer,
                    MyPerform_question: findresponse.MyPerform_question,
                    overallScore: findresponse.overallScore,
                    comment_result: findresponse.comment_result
                })
            })
    }

    getUsersMenu(id) {
        return (
            <ul class="onclick-menu-content">
                {/*<li onClick={() => this.id(id)} data-toggle="modal" data-target="#ViewReport"><a>View Report</a></li>*/}
            </ul>
        )

    }
    userList(page = 1) {
        fetch(this.state.apiUrl + '/MyPerformanceRest/getUsers/page/' + page + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                this.setState({
                    users: findresponse.users,
                    permissions: findresponse.permissions,
                    hr_permission: findresponse.hr_permission,
                    item_count: findresponse.item_count,
                    loading: 0,

                })
            })
    }

    getPermission(permissions) {
        return (
            <div>
                {permissions ? permissions.split("").map(permissions =>
                    <span> {permissions} </span>) : ""}
            </div>
        )
    }


    loadMorecount() {
        if (this.state.item_count > 0) {
            if (this.state.item_count >= 20) {
                if (this.state.isLoadMore != 2) {
                    if (this.state.isLoadMore == 1) {
                        return (
                            <div class="pagination-muvi" id="section07">
                                <div class="load_more" onClick={() => this.loadMore(this.state.activePage)}><span></span><span></span><span></span></div>
                            </div>
                        )
                    }
                    else {
                        return (
                            <div class="pagination-muvi" id="section07">
                                <div class="lds-ripple"><div></div><div></div></div>
                            </div>
                        )
                    }
                }
            }
        }
        else {
            return (
                <div className="text-center">No Data Found</div>
            )
        }
    }

    loadMore(pageNumber) {
        this.setState({ isLoadMore: 0 })
        pageNumber = pageNumber + 1;
        this.setState({ activePage: pageNumber });
        fetch(this.state.apiUrl + '/MyPerformanceRest/getUsers/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey + '/page/' + pageNumber, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                if (findresponse.users.length == 0) {
                    this.setState({
                        isLoadMore: 2
                    })
                } else {
                    this.setState({
                        isLoadMore: 1
                    })
                }
                this.setState({
                    users: this.state.users.concat(findresponse.users),
                })
            })
    }
    getUserRows() {
        if (this.state.loading) {
            return (
                <div class="loader-new"></div>
            )
        } else {
            return (
                <div class="list_check">
                    {this.state.hr_permission == 'yes' ? <div> <div class="tickets hidden-sm">
                        <ul class="tickets_head">
                            <li class="intra_col_25">Employee Name</li>
                            <li class="intra_col_15">Employee Id</li>
                            <li class="intra_col_20">Email ID</li>
                            <li class="intra_col_15">Phone Number</li>
                            <li class="intra_col_20">Department</li>
                            <li class="intra_col_5">Action</li>
                        </ul>
                        {
                            this.state.users.map((user, key) =>
                                <ul class="tickets_number">
                                    <li class="intra_col_25">
                                        <div class="emps_details">
                                            <div class="emps_pic">{user.attachment ? <img src={user.attachment_url + user.attachment} /> : <span class="profile_first_name">{user.name.charAt(0).toUpperCase()}</span>}</div>
                                            <Link key={key} to={`/viewEmployee/${user.id}`} name={"max"}>{user.name}</Link>
                                        </div>
                                    </li>
                                    <li class="intra_col_15">{user.muvi_employee_id}</li>
                                    <li class="intra_col_20">{user.email}</li>
                                    <li class="intra_col_15"> {user.per_phoneno}</li>
                                    <li class="intra_col_20">{user.department}</li>
                                    <li class="intra_col_5">
                                        <div class="edit_delete">
                                            {/* <Link key={key} to={`/viewEmployee/${user.id}`} name={"max"}><i class="fa fa-pencil-square-o" aria-hidden="true"></i></Link>
                                        <span class="delete" onClick={() => this.delete_employee(user.id)}><i class="fa fa-trash" aria-hidden="true"></i></span> */}
                                            <div tabindex="0" class="onclick-menu pull-right">
                                                <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                                                {this.getUsersMenu(user.id)}
                                            </div>
                                        </div>
                                    </li>
                                </ul>

                            )
                        }
                    </div>
                        {
                            this.state.users.map((user, key) =>
                                <div class="customer_mob hidden-md">
                                    <div class="custmer_list_mob emp_mob">
                                        <div class="emps_pic">{user.attachment ? <img src={user.attachment_url + user.attachment} /> : <span class="profile_first_name">{user.name.charAt(0).toUpperCase()}</span>}</div>
                                        <Link key={key} to={`/viewEmployee/${user.id}`} name={"max"}>
                                            <h4 class="list_title">{user.name}</h4>
                                        </Link>
                                        <div class="wrap">{user.position ? user.position : '--'}</div>
                                        <div tabindex="0" class="onclick-menu pull-right">
                                            <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                                            <ul class="onclick-menu-content">
                                                <li onClick={() => this.id(user.id)} data-toggle="modal" data-target="#ViewReport"><a>View Report</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>)} </div> : <div> <div class="tickets hidden-sm">
                                    <ul class="tickets_head">
                                        <li class="intra_col_25">Employee Name</li>
                                        <li class="intra_col_20">Employee Id</li>
                                        <li class="intra_col_25">Email ID</li>
                                        <li class="intra_col_15">Phone Number</li>
                                        <li class="intra_col_15">Department</li>
                                    </ul>
                                    {
                                        this.state.users.map((user, key) =>
                                            <ul class="tickets_number">
                                                <li class="intra_col_25">
                                                    <div class="emps_details">
                                                        <div class="emps_pic">{user.attachment ? <img src={user.attachment_url + user.attachment} /> : <span class="profile_first_name">{user.name.charAt(0).toUpperCase()}</span>}</div>
                                                        <Link key={key} to={`/viewEmployee/${user.id}`} name={"max"}>{user.name}</Link>
                                                    </div>
                                                </li>
                                                <li class="intra_col_20">{user.muvi_employee_id}</li>
                                                <li class="intra_col_25">{user.email}</li>
                                                <li class="intra_col_15"> {user.per_phoneno}</li>
                                                <li class="intra_col_15">
                                                    {user.department}
                                                </li>
                                            </ul>

                                        )
                                    }
                                </div>
                            {
                                this.state.users.map((user, key) =>
                                    <div class="customer_mob hidden-md">
                                        <div class="custmer_list_mob emp_mob">
                                            <div class="emps_pic">{user.attachment ? <img src={user.attachment_url + user.attachment} /> : <span class="profile_first_name">{user.name.charAt(0).toUpperCase()}</span>}</div>
                                            <Link key={key} to={`/viewEmployee/${user.id}`} name={"max"}>
                                                <h4 class="list_title">{user.name}</h4>
                                            </Link>
                                            <div class="wrap">{user.position ? user.position : '--'}</div>

                                        </div>
                                    </div>)}</div>}
                    {this.loadMorecount()}
                </div>
            )
        }
    }

    getRangeCheck() {
        var st_date = moment(this.state.startDate).format("YYYY-MM-DD")
        var en_date = moment(this.state.endDate).format("YYYY-MM-DD")
        if (st_date == en_date) {
            return ''
        }
        else {
            return (
                <p class="feature-check mar_top_20 margin_bottom_less">

                    <input type="checkbox" id="half_day_second" name="half_day_second" class="half_day_second" value onChange={this.onHalfDaySecondChange} />
                    <label for="half_day_second"><span></span>Half Day</label>

                </p>
            )
        }
    }

    componentDidMount() {
        document.title = "Intranet | Performance Reviews";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        this.userList();
        $('.searchTicket.dept').on('click', function () {
            $(this).closest('.intranet_body').find('.filter_dept').slideToggle('slow');
        });
    }
    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }

        return (
            <div>
                <Header brecum_name="Performance Reviews" brecum_page="Peer Review" />
                <div class="right_col">
                    <div class="intranet_body">
                        <div class="title mob hidden-sm">
                            <span>Peer Review</span>
                        </div>
                        <div class="top-row">

                            <div class="right-section pull-right">
                                <div class="row">
                                    <div class="col-md-7 col-xs-12">
                                        <div class="searchTicket emp_dept">
                                            <input type="text" class="form-control" name="search" id="search" placeholder="Search" onChange={this.searchChange} /><button type="submit"><i class="fa fa-search"></i></button>
                                        </div>
                                        <div class="searchTicket filter dept hidden-md"><i class="fa fa-sliders hidden-md filter"></i></div>
                                    </div>
                                    <div class="col-md-5 col-xs-12">
                                        <div class="filter filter_dept">
                                            <select class="form-control" id="department" name="department" onChange={this.departmentChange}>
                                                <option value='all'>All</option>
                                                <option value="Development">Development</option>
                                                <option value="HR & Operations">HR & Operations</option>
                                                <option value="Infra">Infra</option>
                                                <option value="Marketing">Marketing</option>
                                                <option value="Product Management">Product Management</option>
                                                <option value="QA">QA</option>
                                                <option value="Sales">Sales</option>
                                                <option value="Support & Accounts">Support & Accounts</option>
                                            </select>
                                            <i class="fa fa-angle-down" aria-hidden="true"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* <--modal start for View Report-!> */}
                            <div class="modal fade" id="ViewReport" role="dialog">
                                <div class="modal-dialog modal-md">
                                    <div class="modal-content">

                                        <div class="modal-header">
                                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                                            <input type="hidden" name="commentReport" value={this.state.commentReport} />
                                            <h4 class="modal-title">Performance Summary</h4>
                                        </div>
                                        <div class="modal-body">
                                            <div class="row">
                                                <div class="peer-pop">
                                                    <div class="add_dash">
                                                        <div class="dash_price">{this.state.overallScore}</div>
                                                        <div class="dash_wb">Overall Score</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="list_check peer-row">
                                                <div class="tickets">
                                                    <ul class="tickets_head">
                                                        <li class="col-md-9 col-xs-8"><span class="peer-comment">Indicator</span></li>
                                                        <li class="col-md-3 col-xs-4"><span class="peer-comment">Average Score</span></li>
                                                    </ul>
                                                    <div class="peer-block">
                                                        {this.state.MyPerform_answer.map
                                                            ((data, key) =>
                                                                <ul class="tickets_number">
                                                            <li class="col-md-9 col-xs-8">
                                                            <h5>{data.question_name}</h5>
                                                            <p>{data.question_description}</p>
                                                            </li>
                                                            <li class="col-md-3 col-xs-4  peer_res">{data.score}</li>
                                                                </ul>
                                                            )}
                                                    </div>
                                                </div>
                                            </div>
                                    {this.state.comment_result?<span><span class="peer_note">Overall Notes:</span>
                                        <div class="peer-comment note">
                                                {this.state.comment_result.map
                                                    ((data, key) =>
                                                     <div class="peer_comt" dangerouslySetInnerHTML={{__html:data.comment}}/>
                                                    )}
                                               
                                        </div>
                                    </span>:''}
                                    </div>
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-blue" data-dismiss="modal">Close</button>
                                        </div>

                                    </div>

                                </div>
                            </div>
                            {/* <--modal end for View Report-!> */}
                        </div>
                        {this.getUserRows()}
                    </div>
                </div>
            </div>
        );
    }
}
export default PerformanceReviews;


// WEBPACK FOOTER //
// ./src/components/hrAdmin/performanceReviews.js